import Immutable from 'immutable';


export const State = Immutable.fromJS({
	isLoggedIn: false,
  orderId: '',
  isCompleted: false,
});